.info {
  color: var(--color-black);
  font-size: 13px;
  line-height: 1.23em;
  margin-top: 0; /*calc(var(--spacing) * 3);*/

  & p {
    font-size: 13px;
    line-height: 1.23em;
  }

  & p + p {
    margin-top: 1.23em;
  }

  & a {
    color: var(--color-black);
  }
}

.hideOverflow {
  overflow: hidden;
}

.actionDrawer {
  background: white;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border-radius: 0 0 12px 12px;

  @media (--lg) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
